<template>
<div class="chapter">
<div class="inner_page">
<a id="VPS-xiv"></a>
<h2 class="fmt"><span class="bold">List of Tables</span></h2>
<p class="map1">Table 1.1 Losses of the Central Powers During WWI, Austria–Hungary</p>
<p class="map1">Table 1.2 Ethnic Composition of the Kingdom of Hungary’s Population, Prior to and After World War I</p>
<p class="map1">Table 2.1 Order of Battle of the <em class="italic">Honvédség</em>, June 1941–April 1942</p>
<p class="map1">Table 2.2 Organization of Army Corps in 1941</p>
<p class="map1">Table 2.3 Organization of Infantry Brigade in 1941</p>
<p class="map1">Table 2.4 Organization of Mountain Brigade in 1941</p>
<p class="map1">Table 2.5 Organization of Motorized Brigade in 1941</p>
<p class="map1">Table 2.6 Organization of Cavalry Brigade in 1941</p>
<p class="map1">Table 2.7 Armoured Vehicles Ordered According to the Huba III Plan</p>
<p class="map1">Table 2.8 Artillery pieces used by the <em class="italic">Honvédség</em>’s field artillery units in 1943</p>
<p class="map1">Table 2.9 Armoured Vehicles Required vs. Manufactured</p>
<p class="map1">Table 2.10 Authorized Amount of Weapons of the <em class="italic">Honvédség</em> Infantry Divisions, 1943–1945</p>
<p class="map1">Table 2.11 Organization of Szabolcs I and II Infantry Divsions</p>
<p class="map1">Table 2.12 Organization of the Mountain Brigade (March 1944)</p>
<p class="map1">Table 2.13 Comparison of the Organizations of 1943 and 1944 Armoured Divisions</p>
<p class="map1">Table 2.14 Comparison of the Organizations of 1943 and 1944 Cavalry Divisions</p>
<p class="map1">Table 3.1 The Final Production Figures of Turán I</p>
<p class="map1">Table 3.2 Monthly Turán I Production Figures</p>
<p class="map1">Table 3.3 The Final Production Figures of Turán II</p>
<p class="map1">Table 3.4 Monthly Turán II Production Figures</p>
<p class="map1">Table 3.5 Zrínyi II Production Figures</p>
<p class="map1">Table 3.6 List of armoured fighting vehicles received by the <em class="italic">Honvédség</em>, 1939–1945</p>
<p class="map1">Table 3.7 German armour deliveries to the <em class="italic">Honvédség</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tables.vue?5685a42c